// @flow

import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontBold, fontNormal } from "@fdr/static-ui/Typography";

export const ButtonContainer = styled.button`
  display: flex;
  flex-shrink: 0;
  position: relative;
  justify-content: center;
  align-items: center;
  padding: 14px 0;
  background-color: ${buildColor("white", "100")};
  ${({ isActive }) =>
    isActive &&
    css`
      &::after {
        content: "";
        background-color: ${buildColor("blue", "D1")};
        position: absolute;
        height: 1px;
        width: 100%;
        bottom: 0;
        left: 0;
      }
    `};

  & > span:first-child {
    font-size: 12px;
    height: 16px;
    width: 16px;
    outline: 2px solid ${buildColor("white", "100")};
    border-radius: 1px;
  }

  :focus {
    outline: none;
  }
`;

export const RunnerName = styled.span`
  font-size: 14px;
  margin-left: 8px;
  ${({ isActive }) =>
    isActive
      ? css`
          color: ${buildColor("blue", "800")};
          font-family: ${fontBold};
        `
      : css`
          color: ${buildColor("blue", "500")};
          font-family: ${fontNormal};
        `};
`;
